<template>
  <SelectPicker
    v-slot="{ item, selected, active }"
    v-model="selected"
    api-value="/api/currencies/search?query="
    :placeholder-value="placeholderValue"
    :label="label"
    :borders="borders"
  >
    <span
      class="block truncate"
      :class="{ 'font-medium': selected, 'font-normal': !selected }"
    >
      <img
        :src="item.image"
        alt=""
        class="flex-shrink-0 rounded-sm h-4 w-6 mr-3"
      >
    </span>

    <span
      class="block truncate mr-3 font-medium "
      :class="{ 'font-gray-900': selected, 'font-normal': !selected }"
    >
      {{ item.id }}
    </span>
  </SelectPicker>
</template>

<script setup>
import { ref, watch } from 'vue';
import { CheckIcon } from '@heroicons/vue/24/solid';
import SelectPicker from '@/ComponentsDeprecated/Select/SelectPicker';

const props = defineProps({
  modelValue: {
    type: Object,
    required: false,
    default: null,
  },
  placeholderValue: {
    type: String,
    required: false,
    default: 'Currency',
  },
  label: {
    type: String,
    required: false,
    default: 'Select Currency',
  },
  borders: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const emit = defineEmits({ update: (_value) => true });
const selected = ref(props.modelValue);

watch(selected, () => {
  emit('update:modelValue', selected.value);
});

</script>
